var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManajemenWebSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 9.16667V4.16667C16.6667 3.24583 15.9208 2.5 15 2.5H4.16667C3.24583 2.5 2.5 3.24583 2.5 4.16667V15.8333C2.5 16.7542 3.24583 17.5 4.16667 17.5H8.33333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2891 17.256L17.2558 14.2893C17.5816 13.9635 17.5816 13.436 17.2558 13.111L15.9341 11.7893C15.6083 11.4635 15.0808 11.4635 14.7558 11.7893L11.7891 14.756C11.6324 14.9126 11.5449 15.1243 11.5449 15.3451V17.5001H13.6999C13.9208 17.5001 14.1324 17.4126 14.2891 17.256Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.85417 4.57461C4.85167 4.57461 4.85 4.57628 4.85 4.57878C4.85 4.58128 4.85167 4.58294 4.85417 4.58294C4.85667 4.58294 4.85833 4.58128 4.85833 4.57878C4.85833 4.57628 4.85667 4.57461 4.85417 4.57461",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97331 4.57461C6.97081 4.57461 6.96914 4.57628 6.96914 4.57878C6.96914 4.58128 6.97164 4.58294 6.97331 4.58294C6.97581 4.58294 6.97747 4.58128 6.97747 4.57878C6.97747 4.57628 6.97581 4.57461 6.97331 4.57461",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08903 4.57461C9.08653 4.57461 9.08486 4.57628 9.08486 4.57878C9.08486 4.58128 9.08653 4.58294 9.08903 4.58294C9.09153 4.58294 9.0932 4.58128 9.0932 4.57878C9.0932 4.57628 9.09153 4.57461 9.08903 4.57461",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.53857 6.66667H16.6669",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManajemenWebSelected);
export default __webpack_public_path__ + "static/media/manajemenWebSelected.8acb0c88373e5282091ac58689063d5a.svg";
export { ForwardRef as ReactComponent };